import React, { useState, useEffect } from "react";
import {
  createOrder,
  getCustomers,
  getEnquiries,
  getQuotations,
  getOrderById, 
  getQuotationDetail,
  getEnquiryDetail,
  getSellingCost, 
  updatePayment ,
  updateOrder ,
  getEnquiryItems   // 👈 ADD THIS LINE
} from "../services/ipeOrderService";

const IPEOrderCreateDrawer = ({ orderId, drawerMode = "create", onClose, onSuccess }) => {
  // 🔷 UI STATE
  const [isMaximized, setIsMaximized] = useState(false);
  const [order, setOrder] = useState(null);

  // 🔷 SELECTION STATE
  const [customer, setCustomer] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [quotation, setQuotation] = useState("");
  const [mode, setMode] = useState("DIRECT");

  // 🔷 DROPDOWN DATA
  const [customers, setCustomers] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [quotations, setQuotations] = useState([]);

  // 🔷 ITEMS
  const [items, setItems] = useState([
    { sku_id: "", description: "", quantity: 1, rate: 0 }
  ]);

  const [customerPoNo, setCustomerPoNo] = useState("");
  const [customerPoDate, setCustomerPoDate] = useState("");
  const [poReceivedDate, setPoReceivedDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [paymentModal, setPaymentModal] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  // -----------------------------
  // LOAD CUSTOMERS
  // -----------------------------
  
  useEffect(() => {
  if (drawerMode === "edit" && orderId) {
    setOrder(null);  // 🔥 VERY IMPORTANT (clear old data)

    console.log("Reloading order:", orderId);

    loadOrder();
  }
}, [orderId, drawerMode]);
  
  useEffect(() => {
    loadCustomers();
  }, []);

 
const loadOrder = async () => {
  try {
    const res = await getOrderById(orderId);
    //const data = res.data.data;
    const data = res.data.data;

    // 🔥 FORCE DEEP COPY (VERY IMPORTANT)
    data.payment_schedule = [...(data.payment_schedule || [])];
    data.delivery_schedule = [...(data.delivery_schedule || [])];

    setOrder({ ...data });
     //setOrder(data);   // ✅ IMPORTANT FIX
     setOrder(JSON.parse(JSON.stringify(data)));  // 🔥 FORCE NEW OBJECT
    // 1️⃣ SET CUSTOMER
    setCustomer(data.customer_id || "");

    // 2️⃣ LOAD ENQUIRIES FOR CUSTOMER
    const enquiryRes = await getEnquiries();
    const allEnquiries = enquiryRes.data?.data?.items || [];

    const filteredEnquiries = allEnquiries.filter(e =>
      String(e.business_partner_id) === String(data.customer_id)
    );

    setEnquiries(filteredEnquiries);

    // 3️⃣ SET ENQUIRY
    setEnquiry(data.enquiry_id || "");

    // 4️⃣ LOAD QUOTATIONS FOR ENQUIRY
    if (data.enquiry_id) {
      const quotationRes = await getQuotations(data.enquiry_id);

      if (quotationRes.data.data && quotationRes.data.data.header) {
        setQuotations([quotationRes.data.data.header]);
      }
    }

    // 5️⃣ SET QUOTATION
    setQuotation(data.quotation_id || "");
    setCustomerPoNo(data.customer_po_no || "");
    setCustomerPoDate(data.customer_po_date || "");
    setPoReceivedDate(data.po_received_date || "");

    // 6️⃣ SET ITEMS
    setItems(
      (data.items || []).map(i => ({
        sku_id: i.sku_id || "",

        description: i.description,

        equipment_name: i.equipment_name || "",
        product_variant_name: i.product_variant_name || "",

        quantity: i.quantity,
        rate: i.rate
      }))
    );

    // 7️⃣ SET MODE
    setMode("CONVERTED");

  } catch (e) {
    alert("Failed to load order");
  }
}; 
 
const openPaymentModal = (schedule) => {
  console.log("CLICK WORKING", schedule);   // 👈 ADD THIS
  setPaymentModal(schedule);
  setPaymentAmount("");
};

const closePaymentModal = () => {
  setPaymentModal(null);
};
const handlePaymentSubmit = async () => {
  if (!paymentAmount || Number(paymentAmount) <= 0) {
    alert("Enter valid amount");
    return;
  }

  try {
    const payload = {
      order_id: order.id,
      schedule_id: paymentModal.id,
      amount: Number(paymentAmount)
    };

    console.log("PAYLOAD:", payload);

    await updatePayment(payload);

    // 🔥 Refresh UI
    await loadOrder();

    closePaymentModal();

  } catch (e) {
    console.error(e);
    alert(e.response?.data?.message || "Payment update failed");
  }
};

const loadCustomers = async () => {
  try {
    const res = await getCustomers();

    console.log("CUSTOMERS API RESPONSE:", res.data); // 👈 ADD THIS

    setCustomers(res.data.data.items || []);
  } catch (e) {
    console.error(e);
  }
};

  // -----------------------------
  // CUSTOMER CHANGE
  // -----------------------------
  const handleCustomerChange = async (val) => {
  setCustomer(val);
  setEnquiry("");
  setQuotation("");
  setMode("DIRECT");

  try {
    const res = await getEnquiries();

    const all = res.data.data.items || [];

    // 🔥 FRONTEND FILTER
    const filtered = all.filter(e =>
      String(e.business_partner_id) === String(val)
    );

    setEnquiries(filtered);

  } catch (e) {
    console.error(e);
  }
};
  // -----------------------------
  // ENQUIRY CHANGE
  // -----------------------------
  const handleEnquiryChange = async (val) => {
    setEnquiry(val);
    setQuotation("");
    setMode("FETCHED");

    try {
      const res = await getQuotations(val);

      if (res.data.data && res.data.data.header) {
        setQuotations([res.data.data.header]); // wrap single object into array
      } else {
        setQuotations([]);
      }
    } catch (e) {}
  };

  // -----------------------------
  // QUOTATION CHANGE (AUTO FETCH)
  // -----------------------------
  const handleQuotationChange = async (val) => {
  setQuotation(val);

  try {
    // 1️⃣ ENQUIRY ITEMS
    const enquiryRes = await getEnquiryItems(enquiry);
    const enquiryLines = enquiryRes.data?.data?.items || [];

    // 2️⃣ SELLING COST
    const costRes = await getSellingCost(enquiry);
    const costData = costRes.data?.data || {};

    const categoryLines = costData.category_lines || [];

    console.log("ENQUIRY:", enquiryLines);
    console.log("COST:", categoryLines);

    // 🔥 TOTAL SELLING PRICE
    const totalSelling = Number(costData.header?.total_selling_price || 0);

    // 🔥 TOTAL QTY (ENQUIRY)
    const totalQty = enquiryLines.reduce((sum, e) => {
      return sum + Number(e.quantity || 0);
    }, 0);

    // 🔥 DISTRIBUTE PRICE
    const mapped = enquiryLines.map((l) => {

      let rate = 0;

      if (totalQty > 0) {
        const ratio = Number(l.quantity || 0) / totalQty;
        const allocatedValue = totalSelling * ratio;

        rate = allocatedValue / (Number(l.quantity) || 1);
      }

      return {
        sku_id: l.id || "",
        enquiry_item_id: l.id || "",
        equipment_id: l.equipment_id || "",
        description: `${l.equipment_name || ""} - ${l.product_variant_name || ""}`,
        quantity: Number(l.quantity || 0),
        rate: Number(rate.toFixed(2)),

        equipment_name: l.equipment_name,
        product_variant_name: l.product_variant_name
      };
    });

    setItems(mapped);
    setMode("CONVERTED");

  } catch (e) {
    console.error("ERROR:", e);
  }
};
  // -----------------------------
  // ITEM HANDLING
  // -----------------------------
  const handleAddRow = () => {
    setItems([
      ...items,
      { sku_id: "", description: "", quantity: 1, rate: 0 }
    ]);
  };

  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const handleRemove = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const calculateTotal = () => {
    return items.reduce((sum, i) => {
      return sum + (Number(i.quantity) * Number(i.rate));
    }, 0);
  };

  // -----------------------------
  // SUBMIT
  // -----------------------------
  const handleSubmit = async () => {
    setLoading(true);

    if (quotation && !customerPoDate) {
      alert("PO Date is required when quotation is selected");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        order_type: mode,
        client_id: customer || 1,
        enquiry_id: enquiry || null,
        quotation_id: quotation || null,
        customer_po_no: customerPoNo,
        customer_po_date: customerPoDate,
        po_received_date: poReceivedDate,
        items
      };

      if (drawerMode === "edit" && orderId) {
        // 🔥 UPDATE EXISTING ORDER
        await updateOrder(orderId, payload);
        console.log("Order updated:", orderId);
      } else {
        // 🔥 CREATE NEW ORDER
        await createOrder(payload);
        console.log("Order created");
      }

      onSuccess();
      onClose();

    } catch (err) {
      alert(err.response?.data?.message || "Error");
    }

    setLoading(false);
  };

  return (
    <div style={styles.overlay}>
      <div
        style={{
          ...styles.drawer,
          width: isMaximized ? "100%" : "48%"
        }}
      >

        {/* HEADER */}
        <div style={styles.header}>
        <h3>{drawerMode === "edit" ? "Edit Order" : "Create Order"}</h3>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              style={styles.iconBtn}
              onClick={() => setIsMaximized(!isMaximized)}
            >
              {isMaximized ? "🗗" : "⛶"}
            </button>

            <button onClick={onClose} style={styles.closeBtn}>X</button>
          </div>
        </div>

        {/* SELECTION PANEL */}
        <div style={styles.selectionCard}>
          <h4>Order Source</h4>

          <div style={styles.row}>
            <div style={styles.field}>
              <label>Customer</label>
              <select
                style={styles.select}
                value={customer}
                onChange={(e) => handleCustomerChange(e.target.value)}
              >
                <option value="">Select Customer</option>
                {customers.map(c => (
                <option key={c.id} value={c.id}>
                    {c.bp_name}
                </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label>Enquiry</label>
              <select
                style={styles.select}
                value={enquiry}
                onChange={(e) => handleEnquiryChange(e.target.value)}
              >
                <option value="">Select Enquiry</option>
                {enquiries.map(e => (
                  <option key={e.id} value={e.id}>
                    {e.enquiry_no}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label>Quotation</label>
              <select
                style={styles.select}
                value={quotation}
                onChange={(e) => handleQuotationChange(e.target.value)}
              >
                <option value="">Select Quotation</option>
                {quotations.map(q => (
                  <option key={q.id} value={q.id}>
                    {q.quotation_no}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <label>Mode: </label>
            <b>{mode}</b>
          </div>
        </div>
        <div style={{ marginTop: 15 }}>
          <h4>Customer PO Details</h4>

          <div style={styles.row}>
            <div style={styles.field}>
              <label>PO Number</label>
              <input
                style={styles.input}
                value={customerPoNo}
                onChange={(e) => setCustomerPoNo(e.target.value)}
              />
            </div>

            <div style={styles.field}>
              <label>PO Date *</label>
              <input
                type="date"
                style={styles.input}
                value={customerPoDate}
                onChange={(e) => setCustomerPoDate(e.target.value)}
              />
            </div>

            <div style={styles.field}>
              <label>PO Received Date</label>
              <input
                type="date"
                style={styles.input}
                value={poReceivedDate}
                onChange={(e) => setPoReceivedDate(e.target.value)}
              />
            </div>
          </div>
        </div>        
        {/* ITEMS */}
        <div style={styles.section}>
          <h4>Items</h4>
           <table style={styles.table}>      
          <tbody>
            {items.map((row, index) => {
              const amount = Number(row.quantity) * Number(row.rate);

              return (
                <tr key={index}>
                  {/* SKU */}
                  <td>
                    <input
                      style={styles.input}
                      value={row.sku_id}
                      disabled={mode === "CONVERTED"}
                      onChange={(e) =>
                        handleChange(index, "sku_id", e.target.value)
                      }
                    />
                  </td>

                  {/* ✅ EQUIPMENT */}
                  <td>
                    <input
                      style={styles.input}
                      value={row.equipment_name || ""}
                      disabled
                    />
                  </td>

                  {/* ✅ VARIANT */}
                  <td>
                    <input
                      style={styles.input}
                      value={row.product_variant_name || ""}
                      disabled
                    />
                  </td>

                  {/* QTY */}
                  <td>
                    <input
                      type="number"
                      style={styles.input}
                      value={row.quantity}
                      onChange={(e) =>
                        handleChange(index, "quantity", e.target.value)
                      }
                    />
                  </td>

                  {/* RATE */}
                  <td>
                    <input
                      type="number"
                      style={styles.input}
                      value={row.rate}
                      onChange={(e) =>
                        handleChange(index, "rate", e.target.value)
                      }
                    />
                  </td>

                  {/* AMOUNT */}
                  <td style={{ textAlign: "right" }}>
                    {amount.toFixed(2)}
                  </td>

                  {/* DELETE */}
                  <td>
                    <button
                      style={styles.deleteBtn}
                      onClick={() => handleRemove(index)}
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              );
            })}
           </tbody>
          </table>

          {mode !== "CONVERTED" && (
            <button style={styles.addBtn} onClick={handleAddRow}>
              + Add Item
            </button>
          )}
        </div>

        {/* TOTAL */}
        <div style={styles.totalSection}>
          Total: ₹ {calculateTotal().toFixed(2)}
        </div>
        {/* 🔥 ADD HERE */}
        {drawerMode === "edit" && order && (
        <div style={styles.section}>
          <h4>Payment Schedule</h4>

          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Stage</th>
                <th style={styles.th}>%</th>
                <th style={styles.th}>Amount</th>
                <th style={styles.th}>Received</th>
                <th style={styles.th}>Pending</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>

            <tbody>
              {order?.payment_schedule?.map((p, i) => (
                
                 <tr
                    key={`${p.id}-${p.received_amount}-${p.status}`}   // 🔥 IMPORTANT FIX
                    onClick={(e) => e.stopPropagation()}
                  >
                  <td style={styles.td}>{p.stage}</td>
                  <td style={styles.td}>{p.percentage}%</td>
                  <td style={styles.td}>₹ {p.amount}</td>

                  <td style={styles.td}>₹ {p.received_amount}</td>
                  <td style={styles.td}>₹ {p.pending_amount}</td>

                  <td style={styles.td}>{p.status}</td>

                  <td style={styles.td}>
                    {p.status !== "RECEIVED" && (
                      <button
                        style={{
                          ...styles.addBtn,
                          position: "relative",
                           zIndex: 5,
                            pointerEvents: "auto"
                          //opacity: p.status === "RECEIVED" ? 0.5 : 1,
                          //cursor: p.status === "RECEIVED" ? "not-allowed" : "pointer"
                        }}
                        //disabled={p.status === "RECEIVED"}
                        onClick={(e) => {
                          e.stopPropagation();   // 🔥 IMPORTANT
                          console.log("CLICK WORKING", p);
                          openPaymentModal(p);
                        }}
                      >
                        Receive
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}        
       <div style={styles.section}>
        <h4>Delivery Schedule</h4>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Milestone</th>
              <th style={styles.th}>Start Date</th>
              <th style={styles.th}>End Date</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>

          <tbody>
            {order?.delivery_schedule?.map((d, i) => (
              <tr key={i}>
                <td style={styles.td}>{d.milestone}</td>
                <td style={styles.td}>{d.start_date}</td>
                <td style={styles.td}>{d.end_date}</td>
                <td style={styles.td}>{d.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>       
        
        {/* 🔥 PAYMENT MODAL */}
        {paymentModal && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalBox}>
              <h3>Receive Payment</h3>

              <p><b>Stage:</b> {paymentModal.stage}</p>
              <p><b>Pending:</b> ₹ {paymentModal.pending_amount}</p>

              <input
                type="number"
                placeholder="Enter amount"
                value={paymentAmount}
                onChange={(e) => setPaymentAmount(e.target.value)}
                style={styles.input}
              />

              <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
                <button
                  style={styles.saveBtn}
                  onClick={handlePaymentSubmit}
                >
                  Submit
                </button>

                <button style={styles.cancelBtn} onClick={closePaymentModal}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}    
        {/* FOOTER */}
        <div style={styles.footer}></div>  
        {/* ACTIONS */}
        <div style={styles.footer}>
          <button
            style={styles.saveBtn}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Order"}
          </button>

          <button style={styles.cancelBtn} onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 999,
    pointerEvents: "none" 
    
  },

  drawer: {
     height: "100%",
      background: "#f4f6f9",
      padding: 20,
      overflowY: "auto",
      boxShadow: "-4px 0 15px rgba(0,0,0,0.2)",
      transition: "width 0.3s",
     position: "relative",        // 🔥 ADD THIS
     zIndex: 1,
     pointerEvents: "auto"                    // 🔥 ADD THIS
    
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20
  },

  iconBtn: {
    background: "#e5e7eb",
    border: "none",
    padding: "6px 10px",
    cursor: "pointer",
    borderRadius: 4
  },

  closeBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: 4,
    cursor: "pointer"
  },

  selectionCard: {
    padding: 15,
    borderRadius: 8,
    marginBottom: 20,
    background: "#ffffff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  row: {
    display: "flex",
    gap: 15,
    marginTop: 10
  },

  field: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 5
  },

  section: {
     padding: 15,
  background: "#fff",
  borderRadius: 8,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  position: "relative",       // 🔥 ADD THIS
  zIndex: 2                   // 🔥 ADD THIS
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 10
  },
  th: {
  textAlign: "left",
  padding: "8px",
  borderBottom: "1px solid #ddd",
  background: "#f9fafb"
},

td: {
  padding: "8px",
  borderBottom: "1px solid #eee"
},

  input: {
    width: "100%",
    padding: "6px 8px",
    borderRadius: 4,
    border: "1px solid #ccc"
  },

  select: {
    width: "100%",
    padding: "6px 8px",
    borderRadius: 4,
    border: "1px solid #ccc",
    background: "#fff"
  },

  addBtn: {
    
    background: "#6366f1",
    color: "#fff",
    border: "none",
    padding: "6px 14px",
    borderRadius: 4,
    cursor: "pointer"
  },

  totalSection: {
    textAlign: "right",
    marginTop: 20,
    fontSize: 18,
    fontWeight: "bold"
  },

  footer: {
    marginTop: 20,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10
  },

  saveBtn: {
    background: "#16a34a",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: 4,
    cursor: "pointer"
  },

  cancelBtn: {
    background: "#d1d5db",
    border: "none",
    padding: "8px 18px",
    borderRadius: 4,
    cursor: "pointer"
  },

  deleteBtn: {
    background: "transparent",
    border: "none",
    color: "#ef4444",
    cursor: "pointer",
    fontSize: 16
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000
  },
    modalBox: {
    background: "#fff",
    padding: 20,
    borderRadius: 8,
    width: "320px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
  }

};

export default IPEOrderCreateDrawer;